import { render, staticRenderFns } from "./miniprogramLink.vue?vue&type=template&id=6edd6845"
import script from "./miniprogramLink.vue?vue&type=script&lang=js"
export * from "./miniprogramLink.vue?vue&type=script&lang=js"
import style0 from "./miniprogramLink.vue?vue&type=style&index=0&id=6edd6845&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports